import React, { Component } from 'react';
import './style.scss';
import { Tooltip, Zoom } from '@mui/material';

// il tooltip resta ad almeno 8px dai bordi dello schermo (prima poteva attaccarsi al bordo)
const popperProps = {
    modifiers: [
        { name: 'preventOverflow', options: { padding: 8 } },
        { name: 'flip', options: { padding: 8 } }
    ]
};

/**
 * Tooltip di material design: https://material-ui.com/components/tooltips/
 *
 * Parametri da passare:
 * - title (il contenuto da visualizzare nel tooltip)
 * - content (il contenuto su cui deve apparire la label)
 * - position (nel componente è il placement, cioe dove si vuole far apparire il tooltip)
 *
 */
export default class index extends Component {
    render() {

        const { title, position, content } = this.props;

        return (
            <Tooltip
                // lo scroll per i contenuti lunghi sta nel contenitore interno:
                // se fosse sul tooltip, la freccia (che sta fuori dal riquadro) verrebbe tagliata e comparirebbe una barra di scorrimento
                title={title ? <div className="tooltipContent">{title}</div> : ''}
                placement={position}
                TransitionComponent={Zoom}
                arrow
                PopperProps={popperProps}
            >
                {content}
            </Tooltip>
        )
    }
}
